import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const editQuestionStatusSelector = (state: State) =>
  state.editQuestion.status;
export const editQuestionIdSelector = (state: State) =>
  state.editQuestion.entities;
export const editQuestionLoadedSelector = isLoaded(editQuestionStatusSelector);
export const shouldLoadeditQuestionSelector = shouldLoad(
  editQuestionStatusSelector,
);
export const editQuestionRejectedSelector = isRejected(
  editQuestionStatusSelector,
);
export const editQuestionPendingSelector = isPending(
  editQuestionStatusSelector,
);
